import React, { useEffect, useMemo, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { Card, CardBody, Col, Row } from "reactstrap"
import moment from "moment"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { getTeamLookup } from "store/createTeam/action"
import { getReportSubmittedTime } from "store/reportSubmittedTime/action"
import Filter from "./filter"
import ReportTable from "./table"

const ReportSubmittedTime = () => {
  document.title = "Report Submitted Time | TenderSoftware - Flexi TracBoard"

  const dispatch = useDispatch()

  const [startDate, setStartDate] = useState(new Date())
  const [endDate, setEndDate] = useState(new Date())
  const [selectedClient, setSelectedClient] = useState(null)
  const [selectedProject, setSelectedProject] = useState(null)
  const [selectedEmployee, setSelectedEmployee] = useState(null)

  const fromDate = moment(new Date(startDate)).format("YYYY-MM-DD")
  const toDate = moment(new Date(endDate)).format("YYYY-MM-DD")

  const { reportList, companySetting, teamList } = useSelector(state => ({
    reportList: state?.reportSubmittedTime?.reportSubmittedTimeList || [],
    companySetting: state?.Login?.userDetails?.data,
    teamList: state?.createteam?.createTeamLookupList,
  }))

  useEffect(() => {
    dispatch(getTeamLookup())
  }, [])

  const buildParams = (isExport = false) => ({
    fromDate,
    toDate,
    empId: selectedEmployee?.value || selectedEmployee?.id || undefined,
    client: selectedClient?.id || undefined,
    project: selectedProject?.id || undefined,
    export: isExport,
  })

  const loadReport = () => {
    dispatch(getReportSubmittedTime(buildParams(false)))
  }

  useEffect(() => {
    loadReport()
  }, [])

  const handleSubmit = e => {
    e.preventDefault()
    loadReport()
  }

  const handleExport = e => {
    e.preventDefault()
    dispatch(getReportSubmittedTime(buildParams(true), "export"))
  }

  const columns = useMemo(
    () => [
      {
        Header: "Date",
        accessor: "date",
        Cell: ({ value }) => (value ? moment(value).format("YYYY-MM-DD") : ""),
      },
      { Header: "User", accessor: "userName" },
      { Header: "Employee Id", accessor: "empId" },
      {
        Header: companySetting?.MainCategory || "Client",
        accessor: "clientName",
      },
      {
        Header: companySetting?.SubCategory || "Project",
        accessor: "projectName",
      },
      { Header: "Start Time", accessor: "startTime" },
      { Header: "End Time", accessor: "endTime" },
      { Header: "Total Hours", accessor: "totalHours" },
      {
        Header: "Report Submitted Time",
        accessor: "reportInsertedTime",
        Cell: ({ value }) =>
          value ? moment(value).format("YYYY-MM-DD HH:mm:ss") : "",
      },
    ],
    [companySetting]
  )

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs
            title={"Report Submitted Time"}
            breadcrumbItem={"Report Submitted Time"}
          />
          <Card>
            <CardBody>
              <Filter
                startDate={startDate}
                endDate={endDate}
                setStartDate={setStartDate}
                setEndDate={setEndDate}
                handleSubmit={handleSubmit}
                handleExport={handleExport}
                companySetting={companySetting}
                MainCategory={teamList?.categoryLookup}
                SubCategory={teamList?.subCategoryLookup}
                selectedClient={selectedClient}
                setSelectedClient={setSelectedClient}
                selectedProject={selectedProject}
                setSelectedProject={setSelectedProject}
                selectedEmployee={selectedEmployee}
                setSelectedEmployee={setSelectedEmployee}
              />
              <Row>
                <Col xs="12">
                  <ReportTable columns={columns} data={reportList} />
                </Col>
              </Row>
            </CardBody>
          </Card>
        </div>
      </div>
    </React.Fragment>
  )
}

export default ReportSubmittedTime
